export default __webpack_public_path__ + "static/media/sloganBg.48ba1dd9.png";